/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_BodyInputs */

const cs_property_legal_body = /** @type {(inputs: Property_Legal_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustanovení`)
};

const en_property_legal_body = /** @type {(inputs: Property_Legal_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clauses`)
};

/**
* | output |
* | --- |
* | "Clauses" |
*
* @param {Property_Legal_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_body = /** @type {((inputs?: Property_Legal_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_body(inputs)
	return cs_property_legal_body(inputs)
});